export default "__VITE_ASSET__BTkc4lyB__"